module.exports = __webpack_public_path__ + "static/media/firstBuyerImg.126c7ff5.png";